import Link from "next/link";
import verified from "#/assets/badge/verified-badge.svg";
import ExtendedImage from "@/components/ui/extended-image";
import type { Item } from "./types";

const AdvisorCard = ({ item }: { item: Item }) => {
  return (
    <Link
      className="border border-gray-300 p-2 rounded-xl flex flex-col gap-2 max-h-96"
      href={`/bilim-kurulu/${item.id}/article`}
    >
      <ExtendedImage
        alt={`${item.name} image`}
        className="rounded-xl w-full aspect-square grow-0"
        height={176}
        src={item.imageUrl}
        width={176}
      />
      <div className="text-[12px] leading-4.5 font-semibold">
        <h3 className="inline-flex justify-center items-center gap-1">
          {item.name}
          <ExtendedImage
            alt="verified user"
            className="aspect-square object-cover"
            height={16}
            src={verified}
            width={16}
          />
        </h3>
        <h3 className="font-medium opacity-90">{item.title}</h3>
        <p className="line-clamp-3 font-medium">{item.bio}</p>
      </div>
    </Link>
  );
};

export default AdvisorCard;
